import { useAsync, useDesign, useServices, useUser } from '@app/hooks';
import { IframeMessageToChildType } from '@app/types';
import { sendIframeMessageToChild } from '@app/utilities/functions';
import { FC, useEffect, useRef } from 'react';

export const AgenticPage: FC = () => {
  const { avsService } = useServices();
  const { designId } = useDesign();
  const user = useUser();
  const iframe = useRef<HTMLIFrameElement>(null);
  const [designInfo] = useAsync(() => avsService.getDesignInfo(designId), [designId]);

  useEffect(() => {
    if (iframe.current && user) {
      sendIframeMessageToChild(iframe.current, {
        payload: user,
        type: IframeMessageToChildType.auth
      });
    }
  }, [iframe, user]);

  return (!designInfo?.agenticApplications?.length) ? null : (
    <iframe
      allow="microphone"
      className="borderless fullsize"
      ref={iframe}
      src={`${window.dynamicConfig.agenticUrl}?designId=${designId}`}
    />
  );
};
